import { Directive, ElementRef, Inject, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[overflow-tooltip]'
})
export class OverflowTooltipDirective implements AfterViewInit {

  constructor(@Inject(ElementRef) private element: ElementRef) { }

   ngAfterViewInit() {
     setTimeout(() => {
      if (this.element.nativeElement.offsetWidth < this.element.nativeElement.scrollWidth ) {
        this.element.nativeElement.title = this.element.nativeElement.textContent;
    }
     }, 1000);
     /* When using tabbed and pane and so on content init called but,
      view wont be shown at the same time.So put small delay to inject title */
   }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/directives/overflow-tooltip.directive.ts